import { ReputationState, RootState } from '@/store/state_models'
import { Module, ActionContext } from 'vuex'

function getInitialData(): ReputationState {
  return {
    widget: {
      isEditFormEnabled: false,
    },
  }
}

export const reputation: Module<ReputationState, RootState> = {
  namespaced: true,
  state: getInitialData(),
  getters: {
    isWidgetEditFormEnabled: (state: ReputationState) => {
      return state?.widget?.isEditFormEnabled
    },
  },
  mutations: {
    setIsEditFormEnabled: (state: ReputationState, payload: boolean) => {
      state.widget.isEditFormEnabled = payload
    },
  },
  actions: {
    setIsEditFormEnabled: {
      handler: async (
        context: ActionContext<ReputationState, RootState>,
        value: boolean
      ) => {
        context.commit('setIsEditFormEnabled', value)
      },
    },
  },
}
